export enum CallToActionType {
    NotSet = 0,
    PhoneNumber = 1,
    Url = 2,
    MarketplaceLink = 3
}
